<ek-dialog-header>
    <div class="dialog-header">
        <span>{{ modalTitle | translate }}</span>
    </div>
</ek-dialog-header>

<ek-dialog-body>
    <form [formGroup]="subtenantForm" class="subtenant-form">

        <div class="form-field">
            <ek-input-text
                    [id]="'id'"
                    [label]="('INSEGNAMENTO.CREATE_MODAL.ID' | translate) + '*'"
                    [formControlName]="'id'"
                    [fluid]="true"
                    [helpText]="getFieldErrorMessage('id')" />
        </div>

        <div class="form-field">
            <ek-input-text
                    [id]="'name'"
                    [label]="('INSEGNAMENTO.CREATE_MODAL.NAME' | translate) + '*'"
                    [formControlName]="'name'"
                    [fluid]="true"
                    [helpText]="getFieldErrorMessage('name')" />
        </div>

        <div class="form-field">
            <ek-input-text
                    [id]="'degreeClass'"
                    [label]="'INSEGNAMENTO.CREATE_MODAL.DEGREE_CLASS' | translate"
                    [formControlName]="'degreeClass'"
                    [fluid]="true" />
        </div>

        <div class="form-field">
            <ek-input-text
                    [id]="'departmentName'"
                    [label]="'INSEGNAMENTO.CREATE_MODAL.DEPARTMENT_NAME' | translate"
                    [formControlName]="'departmentName'"
                    [fluid]="true" />
        </div>

        <div class="form-field">
            <ek-input-text
                    [id]="'locationName'"
                    [label]="'INSEGNAMENTO.CREATE_MODAL.LOCATION_NAME' | translate"
                    [formControlName]="'locationName'"
                    [fluid]="true" />
        </div>

        <div class="form-field">
            <ek-input-text
                    [id]="'address'"
                    [label]="'INSEGNAMENTO.CREATE_MODAL.ADDRESS' | translate"
                    [formControlName]="'address'"
                    [fluid]="true" />
        </div>

        <div class="form-field">
            <ek-select
                    [label]="'INSEGNAMENTO.CREATE_MODAL.YEAR' | translate"
                    [options]="yearOptions"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [formControlName]="'year'"
                    [styleClass]="'w-full'"
                    [appendTo]="'body'" />
        </div>
    </form>
</ek-dialog-body>

<ek-dialog-footer class="dialog-footer">
    <ek-button (click)="close()"
               [ekStyle]="'outlined'"
               [label]="'INSEGNAMENTO.CREATE_MODAL.ANNULLA' | translate"
               [disabled]="isLoading"
               style="margin-right: 10px;"></ek-button>

    <ek-button (click)="save()"
               [label]="submitLabel | translate"
               [disabled]="!isFormValid"
               [loading]="isLoading"></ek-button>
</ek-dialog-footer>
